import { WorkspaceCountSummary } from '@driftt/api-types'

import { WorkspaceAPI } from 'api'

export const fetchWorkspacesCounts = () =>
  WorkspaceAPI.get<Record<string, WorkspaceCountSummary>>(
    '/workspaces/objects/count'
  )

export const getAllGeoTargetingConfigs = () =>
  WorkspaceAPI.get(`/workspaces/workspaceTargetingConfig`)

export const validateSharedRootUrls = (rootUrls: string[]) =>
  WorkspaceAPI.post(`/workspaces/root_urls/workspaceIds`, { rootUrls })
